import React from 'react'
import { motion } from "framer-motion"

const OneProduct = ({ name, description, originalPrice, price, img, navigateAction }) => {
    return (
        <motion.div 
            className="products__card"
            onClick={navigateAction}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <div className="products__card-left">
                <img src={img} alt={name} className="products__card-img" />
            </div>

            <div className="products__card-center">
                <div className="products__card-title">{name}</div>
                <div className="products__card-description">
                    {description}
                </div>
            </div>

            <div className="products__card-right">
                <div className="products__card-price-original">${originalPrice}</div>
                <div className="products__card-price">${price}</div>
                <div className="products__card-button">View Product</div>
            </div>
        </motion.div>
    )
}

export default OneProduct